import { styled, Box } from '@mui/material';

interface StyledMasonryContainerProps {
  spacingValue: number;
}

interface StyledMasonryColumnProps {
  spacingValue: number;
}

export const StyledMasonryContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'spacingValue',
})<StyledMasonryContainerProps>(({ spacingValue }) => ({
  display: 'flex',
  gap: `${spacingValue}px`,
  alignItems: 'flex-start',
  width: '100%',
}));

export const StyledMasonryColumn = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'spacingValue',
})<StyledMasonryColumnProps>(({ spacingValue }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: `${spacingValue}px`,
  flex: 1,
  minWidth: 0, // Allow flex items to shrink below their content size
}));

export const StyledMasonryItem = styled(Box)({
  width: '100%',
  breakInside: 'avoid',
});